import { mapGetters } from 'vuex';

export default {
  name: 'SuccessOrder',
  props: {
    payload: {
      type: Object
    }
  },
  computed: {
    ...mapGetters({
      isDistributor: 'profile/isDistributor'
    })
  },
  created() {
    document.getElementById('html').classList.add('hide');
  },
  methods: {}
};
